import { connect } from 'react-redux';
import { List, Map } from 'immutable';
import Integrations from '../../../components/AccountPage/components/Integrations';
import {
  requestClients,
  unlinkClient
} from '@xanadu/ui-shared/modules/thirdPartyClients/actions';

const EMPTY_LIST = new List();
const EMPTY_MAP = new Map();

const mapDispatchToProps = {
  requestClients,
  unlinkClient,
};


function mapStateToProps(state) {
  return {
    clients: state.getIn(['thirdPartyClients', 'clients'], EMPTY_LIST),
    clientLogoUris: state.getIn(['thirdPartyClients', 'logoUris'], EMPTY_MAP),
    userIsLoggedIn: state.getIn(['user', 'isLoggedIn'], ''),
    error: state.getIn(['thirdPartyClients', 'error'], ''),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(Integrations);
